<template>
  <div :class="{'checkout-step': true, disabled: currentStep < stepNumber}">
    <div class="ordering__step">
      <div class="ordering__step-image-container">
        <img
          class="ordering__step-image"
          :src="image"
          alt="pyramid"
        >
      </div>
      <div class="ordering__heading-container">
        <slot name="header" />
      </div>
    </div>

    <slot
      v-if="currentStep === stepNumber"
      name="form"
    />
    <slot
      v-if="currentStep > stepNumber"
      name="filled"
    />
  </div>
</template>

<script>
export default {
  name: 'CheckoutStep',
  props: {
    images: {
      type: Array,
      required: true,
    },
    stepNumber: {
      type: Number,
      required: true
    },
    currentStep: {
      type: Number,
      required: true,
    },
  },
  computed: {
    image() {
      if (this.currentStep >= this.stepNumber) {
        return this.images[0]
      } else {
        return this.images[1]
      }
    }
  },
}
</script>

<style lang="scss">
.checkout-step {
  color: var(--font-color);

  &.disabled {
    opacity: .5;
  }
}
</style>
